<template>
    <div>
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate
                                 color="primary"
                                 :size="70"
                                 :width="7"></v-progress-circular>
        </v-overlay>
        <v-alert width="100%" class="pr-2 pl-2" v-if="errorMessage" type="error" dismissible> {{ errorMessage }}</v-alert>
        <v-alert width="100%" class="pr-2 pl-2" v-if="successMessage" type="info" dismissible> {{ successMessage }}</v-alert>

        <v-card>
            <v-alert width="100%" class="pr-2 pl-2" v-if="saveErrorMessage" type="error"> {{ saveErrorMessage }}</v-alert>
            <v-data-table dense class="elevation-1"
                          :headers="headers"
                          :items="luItems"
                          item-key="id"
                          :loading="isLoading"
                          :items-per-page="15">

                <template v-slot:top>
                    <v-toolbar flat>
                        <v-dialog v-model="dialog"
                                  max-width="500px">

                            <template v-slot:activator="{ on, attrs }">
                                <v-spacer></v-spacer>
                                <v-btn color="primary"
                                       dark
                                       class="mb-2"
                                       v-bind="attrs"
                                       v-on="on">
                                    Add
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="text-h5">{{ formTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-form v-model="isValid">
                                            <v-row>
                                                <v-alert width="100%" class="pr-2 pl-2" v-if="errorValidationMessage" type="error"> {{ errorValidationMessage }}</v-alert>
                                            </v-row>
                                            <v-row>

                                                <v-col cols="4">
                                                    <v-text-field v-model="editedItem.pointScheduleId" label="Id*" :disabled="editedIndex != -1"
                                                                  :rules="[(v) => !!v || 'Required',(v) =>v.length <= 2 || 'Limited to 2 chars.',]" />
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.dogCntMin" label=" Dog Count Min*"
                                                                  :rules="[(v) => !!v || 'Required',(v) => !isNaN(v) || 'Invalid Number',]" />
                                                </v-col>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.dogCntMax" label=" Dog Count Max*"
                                                                  :rules="[(v) => !!v || 'Required',(v) => !isNaN(v) || 'Invalid Number',]" />
                                                </v-col>


                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.pointsLvl1" label=" Points Lvl1*"
                                                                  :rules="[(v) => !!v || 'Required',(v) => !isNaN(v) || 'Invalid Number',]" />
                                                </v-col>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.dogCntLvl1" label="Dog Count Lvl1*"
                                                                  :rules="[(v) => !!v || 'Required',(v) => !isNaN(v) || 'Invalid Number',]" />
                                                </v-col>


                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.pointsLvl2" label=" Points Lvl2*"
                                                                  :rules="[(v) => !!v || 'Required',(v) => !isNaN(v) || 'Invalid Number',]" />
                                                </v-col>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.dogCntLvl2" label="Dog Count Lvl2*"
                                                                  :rules="[(v) => !!v || 'Required',(v) => !isNaN(v) || 'Invalid Number',]" />
                                                </v-col>


                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.pointsLvl3" label=" Points Lvl3*"
                                                                  :rules="[(v) => !!v || 'Required',(v) => !isNaN(v) || 'Invalid Number',]" />
                                                </v-col>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.dogCntLvl3" label="Dog Count Lvl3*"
                                                                  :rules="[(v) => !!v || 'Required',(v) => !isNaN(v) || 'Invalid Number',]" />
                                                </v-col>


                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.pointsLvl4" label=" Points Lvl4*"
                                                                  :rules="[(v) => !!v || 'Required',(v) => !isNaN(v) || 'Invalid Number',]" />
                                                </v-col>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.dogCntLvl4" label="Dog Count Lvl4*"
                                                                  :rules="[(v) => !!v || 'Required',(v) => !isNaN(v) || 'Invalid Number',]" />
                                                </v-col>


                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.pointsLvl5" label=" Points Lvl5*"
                                                                  :rules="[(v) => !!v || 'Required',(v) => !isNaN(v) || 'Invalid Number',]" />
                                                </v-col>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.dogCntLvl5" label="Dog Count Lvl5*"
                                                                  :rules="[(v) => !!v || 'Required',(v) => !isNaN(v) || 'Invalid Number',]" />
                                                </v-col>


                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1"
                                           text
                                           @click="close">
                                        Cancel
                                    </v-btn>
                                    <v-btn color="blue darken-1"
                                           text
                                           :disabled="!isValid"
                                           @click="save">
                                        Add/Update
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialogDelete" max-width="500px">
                            <v-card>
                                <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon small
                            class="mr-2"
                            @click="editItem(item)">
                        mdi-pencil
                    </v-icon>
                    <v-icon small v-if="item.canDelete"
                            @click="deleteItem(item)">
                        mdi-delete
                    </v-icon>
                </template>

            </v-data-table>





            <br /><br /><br />
            <v-row>
                <v-col>
                    <DatepickerFormatted :disableClearable="true"
                                         :date="startDate"
                                         label="From Date"
                                         v-on:updateDates="($event) => { startDate = $event.date; }" />
                </v-col>
                <v-col>
                    <DatepickerFormatted :disableClearable="true"
                                         :date="endDate"
                                         label="To Date"
                                         v-on:updateDates="($event) => { endDate = $event.date; }" />
                </v-col>
                <v-col>
                    <v-btn color="primary" v-on:click="affiliatesGeneratePointSchedules">
                        Regenerate
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import DatepickerFormatted from "@/components/common/inputs/DatepickerFormatted.vue";

import lookupsService from "@/services/admin/lookupsService";
import affiliateService from "@/services/admin/affiliateService";
import { PointScheduleLookupInfo } from '@/types/admin/Lookup';

export default Vue.extend({
  name: "PointSchedulesMaintenance",
  components: {
    DatepickerFormatted
  },
  data: function() {
    return {
        errorMessage: null as any,
        successMessage: null as any,
        startDate: null as any,
        endDate: null as any,
        luItems: [] as PointScheduleLookupInfo[],
        dialog: false,
        dialogDelete: false,
        headers: [
            { text: "ID", align: "left", value: "pointScheduleId" },
            { text: "Dog Count Min", align: "left", value: "dogCntMin" },
            { text: "Dog Count Max", align: "left", value: "dogCntMax" },
            { text: "Dog Count Lvl1", align: "left", value: "dogCntLvl1" },
            { text: "Points Lvl1", align: "left", value: "pointsLvl1" },
            { text: "Dog Count Lvl2", align: "left", value: "dogCntLvl2" },
            { text: "Points Lvl2", align: "left", value: "pointsLvl2" },
            { text: "Dog Count Lvl3", align: "left", value: "dogCntLvl3" },
            { text: "Points Lvl3", align: "left", value: "pointsLvl3" },
            { text: "Dog Count Lvl4", align: "left", value: "dogCntLvl4" },
            { text: "Points Lvl4", align: "left", value: "pointsLvl4" },
            { text: "Dog Count Lvl5", align: "left", value: "dogCntLvl5" },
            { text: "Points Lvl5", align: "left", value: "pointsLvl5" },
            { text: "Actions", value: "actions", sortable: false },
        ],
        editedIndex: -1,
        editedItem: {
            pointScheduleId: "",
            dogCntMin: 0,
            dogCntMax: 0,
            dogCntLvl1: 0,
            dogCntLvl2: 0,
            dogCntLvl3: 0,
            dogCntLvl4: 0,
            dogCntLvl5: 0,
            pointsLvl1: 1,
            pointsLvl2: 2,
            pointsLvl3: 3,
            pointsLvl4: 4,
            pointsLvl5: 5,
            canDelete:true,

        },
        defaultItem: {
            pointScheduleId: "",
            dogCntMin: 0,
            dogCntMax: 0,
            dogCntLvl1: 0,
            dogCntLvl2: 0,
            dogCntLvl3: 0,
            dogCntLvl4: 0,
            dogCntLvl5: 0,
            pointsLvl1: 1,
            pointsLvl2: 2,
            pointsLvl3: 3,
            pointsLvl4: 4,
            pointsLvl5: 5,
            canDelete: true,
            
        },              
        isValid: true,
        errorValidationMessage: "",
        isLoading: false,
        saveErrorMessage: "",
    };
  },
    created: function () {
        var currentDate = new Date();
        var firstFebLastYear = new Date(currentDate.getFullYear() - 1, 1, 1);
        this.startDate = this.$dateUtils.formatDateISO(firstFebLastYear);
        var lastJanThisYear = new Date(currentDate.getFullYear(), 0, 31);
        this.endDate = this.$dateUtils.formatDateISO(lastJanThisYear);

        this.reloadItems();
    },
    methods: {
        affiliatesGeneratePointSchedules: function () {
            this.$store.dispatch("changeLoaderStatus", true);
            affiliateService.affiliatesGeneratePointSchedules(this.startDate, this.endDate)
                .then((res) => {
                    if (!res.success) {
                        this.errorMessage = res.messages.join(', ')
                    } else {
                        this.successMessage = res.messages.join(', ')
                    }
                })
                .catch(() => { this.errorMessage = "Operation failed." })
                .finally(() => { this.$store.dispatch("changeLoaderStatus", false); });
        },
        reloadItems: function () {
            this.$data.isLoading = true;
            lookupsService.getPointScheduleList().then((res: any) => {
                this.luItems = res;
                this.$data.isLoading = false;

            }).catch(() => { this.errorMessage = "Unable to add/update Point Schedule." })
                .finally(() => { this.$store.dispatch("changeLoaderStatus", false); });

            this.$data.isLoading = false;
        },
        initializeItem() {
           
            this.dialog = true;

        },

        editItem(item: PointScheduleLookupInfo) {
            this.editedIndex = this.luItems.indexOf(item)
            this.editedItem = Object.assign({}, item);
            
            this.dialog = true;
        },

        deleteItem(item: PointScheduleLookupInfo) {
            this.editedIndex = this.luItems.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },
        deleteItemConfirm() {
            this.errorValidationMessage = "";
            this.saveErrorMessage = "";
            if (!this.editedItem.canDelete) {
                this.closeDelete();
            }
            lookupsService.deletePointSchedule(this.editedItem.pointScheduleId).then((res) => {
                if (res.success == false) {
                    this.saveErrorMessage = res.messages.join(', ')

                }
                else {
                    this.luItems.splice(this.editedIndex, 1);
                }

                this.reloadItems(); //in case something was changed after that pull

            }).catch((e: any) => {
                this.saveErrorMessage = "Unable to delete the point schedule.";   
            });

            this.closeDelete();


        },

        close() {
            this.errorValidationMessage = "";
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        closeDelete() {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        save() {
            this.errorValidationMessage = "";
            this.saveErrorMessage = "";
            this.editedItem.pointScheduleId = this.editedItem.pointScheduleId.trim();
            if (this.editedItem.pointScheduleId.length == 0) {
                this.errorValidationMessage = "Please enter valid values."
                return;
            }

            if (!/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/i.test(this.editedItem.pointScheduleId)) {
                this.errorValidationMessage  = "Please enter valid values."
                return;
            }

            if (this.editedItem.pointScheduleId.includes(' ')) {
                this.errorValidationMessage  = "Please enter valid values."
                return;
            }

            if (this.editedIndex == -1) {
                var exists = this.luItems.find((x: any) => x.pointScheduleId.trim() == this.editedItem.pointScheduleId);
                if (exists != null) {
                    this.errorValidationMessage  = "This Id already exists.";
                    return;
                }
               
            }
            
            lookupsService.editPointSchedule(this.editedItem)
                .then((res) => { 
                    if (res.success) {
                        if (this.editedIndex > -1) { 
                            Object.assign(this.luItems[this.editedIndex], this.editedItem)
                        }
                        else {                       
                            if (this.luItems) {
                                this.luItems.unshift(this.editedItem) 
                            }
                            
                        }
                        this.close();
                    }
                    else {
                        this.errorValidationMessage = res.messages.join(', ')
                        this.reloadItems(); //in case something was changed after that pull
                    }
                })
                .catch(() => {
                    this.errorValidationMessage = "Invalid values, please enter only numbers.";
                })
                .finally(() => this.$store.dispatch("changeLoaderStatus", false));

        },
        

    },
    computed: {
        formTitle() {
            return this.$data.editedIndex === -1 ? "New Item" : "Edit Item";
        },
    },
});
</script>
